import React, { Dispatch } from 'react'

import styled from 'styled-components'
import { Col, NavItem, NavLink } from 'reactstrap'
import { FilterProps } from 'models/filter.model'

const BorderBottomCol = styled(Col)`
  border-bottom: 1px solid #dee2e6;
  padding: 0;
  max-width: 97%;
  a:hover,
  span:hover {
    filter: brightness(80%);
`

const Filters: React.FC<FilterProps> = ({ motifsByLanguage, motifs, activeTab, setActiveTab, referenceRows, setFilteredRows, setOffset }) => {
  return (
    <BorderBottomCol className='nav' lg='12'>
      {motifsByLanguage.map((motifByLanguage: string, index: number) => (
        // <NavWrapper>
        <NavItem key={index}>
          <NavLink
            className={activeTab === index ? 'active' : ''}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setActiveTab(index)
              if (motifs[index] === 'Tous') {
                setFilteredRows(referenceRows)
              }
              setOffset?.(0)
            }}
          >
            {motifByLanguage}
          </NavLink>
        </NavItem>
      ))}
    </BorderBottomCol>
  )
}

export default Filters
